module.exports = __webpack_public_path__ + "static/media/gradient-oval.65b890a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gradient-oval.png
// module id = 472
// module chunks = 0